import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=5494bcdd&scoped=true&"
import script from "./Response.vue?vue&type=script&lang=js&"
export * from "./Response.vue?vue&type=script&lang=js&"
import style0 from "./Response.vue?vue&type=style&index=0&id=5494bcdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5494bcdd",
  null
  
)

export default component.exports